import state from './moduleApDocumentsState.js'
import mutations from './moduleApDocumentsMutations.js'
import actions from './moduleApDocumentsActions.js'
import getters from './moduleApDocumentsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

